import { generateDeepDiffs } from '@shared/utils/generateDeepDiffs.js';
import filterWorkflowDiffs from '@/lib/buildWorkflowSnapshotDiffs/filterWorkflowDiffs.js';
import filterStepDiffs from '@/lib/buildWorkflowSnapshotDiffs/filterStepDiffs.js';

const buildWorkflowSnapshotDiffs = (prevObj, newObj) => {
  if (!newObj || !prevObj || !newObj?.steps) {
    return [];
  }

  const newStepDiffs = newObj?.steps
    ?.filter((n) => !prevObj?.steps?.find((o) => o?.id === n?.id))
    .map((n) => ({
      type: 'operation',
      operation: 'add',
      stepId: n?.id,
      newValue: n
    }));

  const oldStepDiffs = prevObj?.steps
    ?.filter((o) => !newObj?.steps?.find((n) => n?.id === o?.id))
    .map((n) => ({
      type: 'operation',
      operation: 'delete',
      appSlug: n?.appSlug,
      message: n?.message,
      stepId: n?.id,
      previousValue: n
    }));

  const stepDiffs = prevObj?.steps
    ?.map((oldStep) => {
      const newStep = newObj?.steps?.find((o) => o?.id === oldStep?.id);
      return !newStep
        ? null
        : filterStepDiffs(generateDeepDiffs(oldStep, newStep)).map((n) => ({
            type: oldStep?.type === 'trigger' ? 'trigger' : 'step',
            stepId: oldStep?.id,
            ...n
          }));
    })
    .filter((n) => !!n && n?.length > 0)
    .flat();

  const { steps: oldSteps, graph: oldGraph, ...prevWorkflow } = prevObj;
  const { steps: newSteps, graph: newGraph, ...newWorkflow } = newObj;
  const workflowDiffs = filterWorkflowDiffs(generateDeepDiffs(prevWorkflow, newWorkflow)).map((n) => ({
    type: 'workflow',
    workflowId: prevObj?.id,
    ...n
  }));

  return [...workflowDiffs, ...newStepDiffs, ...oldStepDiffs, ...stepDiffs].map((n) => {
    const id = [n.type, n.workflowId, n.stepId, n.key].filter((n) => !!n).join('-');
    return { id, ...n };
  });
};

export default buildWorkflowSnapshotDiffs;
